import { useNewTranslations } from '@/common/translations';
import PreviousMeetingsStatColumn from './PreviousMeetingsStatColumn';

export interface StatsPreviousMeetingsProps {
  /** Wins for the home side in head-to-head (first column). */
  homeWins: number;
  /** Draw count in head-to-head (middle column). */
  draws: number;
  /** Wins for the away side in head-to-head (third column). */
  awayWins: number;
  /** Home team jersey image URL. */
  homeJerseySrc: string;
  /** Draw / neutral jersey image URL. */
  drawJerseySrc: string;
  /** Away team jersey image URL. */
  awayJerseySrc: string;
  /** Optional className for the root wrapper. */
  className?: string;
}

export default function StatsPreviousMeetings({
  homeWins,
  draws,
  awayWins,
  homeJerseySrc,
  awayJerseySrc,
  drawJerseySrc,
  className = '',
}: StatsPreviousMeetingsProps) {
  const translate = useNewTranslations();
  const winLabel = translate('PreMatchStats.Won');
  const drawLabel = translate('PreMatchStats.Draw');

  return (
    <div className={`flex items-start justify-center gap-[8px] py-[16px] w-full ${className}`}>
      <PreviousMeetingsStatColumn jerseySrc={homeJerseySrc} number={homeWins} label={winLabel} />
      <PreviousMeetingsStatColumn jerseySrc={drawJerseySrc} number={draws} label={drawLabel} />
      <PreviousMeetingsStatColumn jerseySrc={awayJerseySrc} number={awayWins} label={winLabel} />
    </div>
  );
}
